import React, { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../ui/tabs';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';
import { ArrowUp, ArrowDown, TrendingUp, Clock, Video, Heart, MessageCircle, Share2, Eye, UserRound } from 'lucide-react';
// Sample data
const overviewData = [{
  name: 'Mon',
  views: 2400,
  likes: 1200,
  comments: 800,
  shares: 400
}, {
  name: 'Tue',
  views: 1398,
  likes: 800,
  comments: 500,
  shares: 210
}, {
  name: 'Wed',
  views: 9800,
  likes: 3908,
  comments: 2000,
  shares: 1800
}, {
  name: 'Thu',
  views: 3908,
  likes: 2000,
  comments: 1500,
  shares: 800
}, {
  name: 'Fri',
  views: 4800,
  likes: 2400,
  comments: 1600,
  shares: 1000
}, {
  name: 'Sat',
  views: 3800,
  likes: 1800,
  comments: 1200,
  shares: 700
}, {
  name: 'Sun',
  views: 4300,
  likes: 2300,
  comments: 1400,
  shares: 900
}];
const contentData = [{
  id: 1,
  title: 'Shower Scene #morning',
  date: '2023-05-10',
  impressions: 24500,
  reach: 18300,
  engagement: 9.2,
  revenue: 345
}, {
  id: 2,
  title: 'Bedroom Talk ASMR',
  date: '2023-05-08',
  impressions: 18900,
  reach: 15200,
  engagement: 7.8,
  revenue: 210
}, {
  id: 3,
  title: 'Try-on Haul (Premium)',
  date: '2023-05-05',
  impressions: 32100,
  reach: 28400,
  engagement: 12.5,
  revenue: 580
}, {
  id: 4,
  title: 'Q&A with Fans #live',
  date: '2023-05-01',
  impressions: 15800,
  reach: 12600,
  engagement: 8.1,
  revenue: 195
}];
const audienceData = [{
  name: '18-24',
  male: 15,
  female: 25,
  other: 5
}, {
  name: '25-34',
  male: 25,
  female: 35,
  other: 8
}, {
  name: '35-44',
  male: 20,
  female: 15,
  other: 5
}, {
  name: '45+',
  male: 10,
  female: 5,
  other: 2
}];
const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];
export function AnalyticsSection() {
  const [overviewTab, setOverviewTab] = useState('overview');
  return <div className="w-full space-y-6" data-id="element-3275">
      <Tabs defaultValue="overview" className="w-full" data-id="element-3276">
        <TabsList className="mb-4" data-id="element-3277">
          <TabsTrigger value="overview" data-id="element-3278">Overview</TabsTrigger>
          <TabsTrigger value="content" data-id="element-3279">Content</TabsTrigger>
          <TabsTrigger value="audience" data-id="element-3280">Audience</TabsTrigger>
          <TabsTrigger value="live" data-id="element-3281">Live</TabsTrigger>
          <TabsTrigger value="shop" data-id="element-3282">Shop</TabsTrigger>
        </TabsList>
        <TabsContent value="overview" className="space-y-6" data-id="element-3283">
          {/* KPI Cards */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-3284">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3285">
              <div className="flex justify-between items-start" data-id="element-3286">
                <div data-id="element-3287">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3288">
                    Total Views
                  </p>
                  <h3 className="text-2xl font-bold mt-1" data-id="element-3289">1.2M</h3>
                </div>
                <div className="p-2 bg-blue-100 dark:bg-blue-900/30 rounded-lg" data-id="element-3290">
                  <Eye className="w-5 h-5 text-blue-500 dark:text-blue-400" data-id="element-3291" />
                </div>
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-3292">
                <ArrowUp className="w-4 h-4 text-green-500 mr-1" data-id="element-3293" />
                <span className="text-green-500 font-medium" data-id="element-3294">12.5%</span>
                <span className="text-gray-500 dark:text-gray-400 ml-1" data-id="element-3295">
                  vs last period
                </span>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3296">
              <div className="flex justify-between items-start" data-id="element-3297">
                <div data-id="element-3298">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3299">
                    Likes
                  </p>
                  <h3 className="text-2xl font-bold mt-1" data-id="element-3300">450K</h3>
                </div>
                <div className="p-2 bg-red-100 dark:bg-red-900/30 rounded-lg" data-id="element-3301">
                  <Heart className="w-5 h-5 text-red-500 dark:text-red-400" data-id="element-3302" />
                </div>
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-3303">
                <ArrowUp className="w-4 h-4 text-green-500 mr-1" data-id="element-3304" />
                <span className="text-green-500 font-medium" data-id="element-3305">8.3%</span>
                <span className="text-gray-500 dark:text-gray-400 ml-1" data-id="element-3306">
                  vs last period
                </span>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3307">
              <div className="flex justify-between items-start" data-id="element-3308">
                <div data-id="element-3309">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3310">
                    Comments
                  </p>
                  <h3 className="text-2xl font-bold mt-1" data-id="element-3311">32.4K</h3>
                </div>
                <div className="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-lg" data-id="element-3312">
                  <MessageCircle className="w-5 h-5 text-purple-500 dark:text-purple-400" data-id="element-3313" />
                </div>
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-3314">
                <ArrowUp className="w-4 h-4 text-green-500 mr-1" data-id="element-3315" />
                <span className="text-green-500 font-medium" data-id="element-3316">15.2%</span>
                <span className="text-gray-500 dark:text-gray-400 ml-1" data-id="element-3317">
                  vs last period
                </span>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3318">
              <div className="flex justify-between items-start" data-id="element-3319">
                <div data-id="element-3320">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3321">
                    Profile Views
                  </p>
                  <h3 className="text-2xl font-bold mt-1" data-id="element-3322">89.5K</h3>
                </div>
                <div className="p-2 bg-green-100 dark:bg-green-900/30 rounded-lg" data-id="element-3323">
                  <UserRound className="w-5 h-5 text-green-500 dark:text-green-400" data-id="element-3324" />
                </div>
              </div>
              <div className="flex items-center mt-2 text-sm" data-id="element-3325">
                <ArrowDown className="w-4 h-4 text-red-500 mr-1" data-id="element-3326" />
                <span className="text-red-500 font-medium" data-id="element-3327">3.1%</span>
                <span className="text-gray-500 dark:text-gray-400 ml-1" data-id="element-3328">
                  vs last period
                </span>
              </div>
            </div>
          </div>
          {/* Growth Graph */}
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3329">
            <h3 className="text-lg font-semibold mb-4" data-id="element-3330">Growth Trends</h3>
            <div className="h-80" data-id="element-3331">
              <ResponsiveContainer width="100%" height="100%" data-id="element-3332">
                <LineChart data={overviewData} data-id="element-3333">
                  <CartesianGrid strokeDasharray="3 3" stroke="#374151" data-id="element-3334" />
                  <XAxis dataKey="name" stroke="#6B7280" data-id="element-3335" />
                  <YAxis stroke="#6B7280" data-id="element-3336" />
                  <Tooltip contentStyle={{
                  backgroundColor: '#1F2937',
                  borderColor: '#374151',
                  color: '#F9FAFB'
                }} data-id="element-3337" />
                  <Line type="monotone" dataKey="views" stroke="#8884d8" strokeWidth={2} activeDot={{
                  r: 8
                }} data-id="element-3338" />
                  <Line type="monotone" dataKey="likes" stroke="#82ca9d" strokeWidth={2} data-id="element-3339" />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          {/* Widgets Row */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-3340">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3341">
              <div className="flex items-center justify-between mb-4" data-id="element-3342">
                <h3 className="text-md font-semibold" data-id="element-3343">Top Posts</h3>
                <TrendingUp className="w-5 h-5 text-green-500" data-id="element-3344" />
              </div>
              <ul className="space-y-3" data-id="element-3345">
                <li className="flex items-center justify-between" data-id="element-3346">
                  <span className="text-sm truncate flex-1" data-id="element-3347">
                    Shower Scene #morning
                  </span>
                  <span className="text-green-500 text-sm font-medium" data-id="element-3348">
                    24.5K views
                  </span>
                </li>
                <li className="flex items-center justify-between" data-id="element-3349">
                  <span className="text-sm truncate flex-1" data-id="element-3350">
                    Try-on Haul (Premium)
                  </span>
                  <span className="text-green-500 text-sm font-medium" data-id="element-3351">
                    32.1K views
                  </span>
                </li>
                <li className="flex items-center justify-between" data-id="element-3352">
                  <span className="text-sm truncate flex-1" data-id="element-3353">
                    Bedroom Talk ASMR
                  </span>
                  <span className="text-green-500 text-sm font-medium" data-id="element-3354">
                    18.9K views
                  </span>
                </li>
              </ul>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3355">
              <div className="flex items-center justify-between mb-4" data-id="element-3356">
                <h3 className="text-md font-semibold" data-id="element-3357">Most Engaged Time</h3>
                <Clock className="w-5 h-5 text-blue-500" data-id="element-3358" />
              </div>
              <div className="flex flex-col items-center justify-center h-32" data-id="element-3359">
                <h2 className="text-3xl font-bold" data-id="element-3360">9PM - 11PM</h2>
                <p className="text-sm text-gray-500 dark:text-gray-400 mt-2" data-id="element-3361">
                  Highest engagement window
                </p>
              </div>
              <div className="mt-2 text-sm text-center" data-id="element-3362">
                <p className="text-gray-500 dark:text-gray-400" data-id="element-3363">
                  Consider scheduling posts during this time frame
                </p>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3364">
              <div className="flex items-center justify-between mb-4" data-id="element-3365">
                <h3 className="text-md font-semibold" data-id="element-3366">
                  Best Performing Format
                </h3>
                <Video className="w-5 h-5 text-purple-500" data-id="element-3367" />
              </div>
              <div className="h-40" data-id="element-3368">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3369">
                  <PieChart data-id="element-3370">
                    <Pie data={[{
                    name: 'Videos',
                    value: 65
                  }, {
                    name: 'Photos',
                    value: 25
                  }, {
                    name: 'Lives',
                    value: 10
                  }]} cx="50%" cy="50%" innerRadius={40} outerRadius={60} fill="#8884d8" paddingAngle={5} dataKey="value" data-id="element-3371">
                      {[0, 1, 2].map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-3372" />)}
                    </Pie>
                    <Tooltip data-id="element-3373" />
                  </PieChart>
                </ResponsiveContainer>
              </div>
              <div className="flex justify-center space-x-4 mt-2" data-id="element-3374">
                <div className="flex items-center" data-id="element-3375">
                  <div className="w-3 h-3 rounded-full bg-[#0088FE] mr-1" data-id="element-3376"></div>
                  <span className="text-xs" data-id="element-3377">Videos</span>
                </div>
                <div className="flex items-center" data-id="element-3378">
                  <div className="w-3 h-3 rounded-full bg-[#00C49F] mr-1" data-id="element-3379"></div>
                  <span className="text-xs" data-id="element-3380">Photos</span>
                </div>
                <div className="flex items-center" data-id="element-3381">
                  <div className="w-3 h-3 rounded-full bg-[#FFBB28] mr-1" data-id="element-3382"></div>
                  <span className="text-xs" data-id="element-3383">Lives</span>
                </div>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="content" className="space-y-4" data-id="element-3384">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm overflow-hidden" data-id="element-3385">
            <div className="p-4" data-id="element-3386">
              <h3 className="text-lg font-semibold mb-2" data-id="element-3387">
                Content Performance
              </h3>
              <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3388">
                Track how your individual posts are performing
              </p>
            </div>
            <div className="overflow-x-auto" data-id="element-3389">
              <table className="w-full" data-id="element-3390">
                <thead className="bg-gray-50 dark:bg-gray-700" data-id="element-3391">
                  <tr data-id="element-3392">
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-3393">
                      Title
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-3394">
                      Date
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-3395">
                      Impressions
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-3396">
                      Reach
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-3397">
                      Engagement
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-3398">
                      Revenue
                    </th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-300 uppercase tracking-wider" data-id="element-3399">
                      Tags
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200 dark:divide-gray-600" data-id="element-3400">
                  {contentData.map(item => <tr key={item.id} className="hover:bg-gray-50 dark:hover:bg-gray-700/50" data-id="element-3401">
                      <td className="px-4 py-4 whitespace-nowrap text-sm font-medium" data-id="element-3402">
                        {item.title}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500 dark:text-gray-400" data-id="element-3403">
                        {item.date}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-3404">
                        {item.impressions.toLocaleString()}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-3405">
                        {item.reach.toLocaleString()}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-3406">
                        {item.engagement}%
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-3407">
                        ${item.revenue}
                      </td>
                      <td className="px-4 py-4 whitespace-nowrap text-sm" data-id="element-3408">
                        {item.title.includes('Premium') && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200 mr-1" data-id="element-3409">
                            Premium
                          </span>}
                        {item.title.includes('Shower') && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200 mr-1" data-id="element-3410">
                            NSFW
                          </span>}
                        {item.title.includes('live') && <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200" data-id="element-3411">
                            Live
                          </span>}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="audience" className="space-y-4" data-id="element-3412">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3413">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3414">
              <h3 className="text-lg font-semibold mb-4" data-id="element-3415">Demographics</h3>
              <div className="h-80" data-id="element-3416">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3417">
                  <BarChart data={audienceData} layout="vertical" margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5
                }} data-id="element-3418">
                    <CartesianGrid strokeDasharray="3 3" stroke="#374151" data-id="element-3419" />
                    <XAxis type="number" stroke="#6B7280" data-id="element-3420" />
                    <YAxis dataKey="name" type="category" stroke="#6B7280" data-id="element-3421" />
                    <Tooltip contentStyle={{
                    backgroundColor: '#1F2937',
                    borderColor: '#374151',
                    color: '#F9FAFB'
                  }} data-id="element-3422" />
                    <Bar dataKey="male" fill="#3B82F6" name="Male" data-id="element-3423" />
                    <Bar dataKey="female" fill="#EC4899" name="Female" data-id="element-3424" />
                    <Bar dataKey="other" fill="#10B981" name="Other" data-id="element-3425" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3426">
              <h3 className="text-lg font-semibold mb-4" data-id="element-3427">Viewer Types</h3>
              <div className="flex justify-center items-center h-80" data-id="element-3428">
                <div className="w-64 h-64 relative" data-id="element-3429">
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-3430">
                    <div className="text-center" data-id="element-3431">
                      <h4 className="text-xl font-bold" data-id="element-3432">65%</h4>
                      <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3433">
                        Returning
                      </p>
                    </div>
                  </div>
                  <ResponsiveContainer width="100%" height="100%" data-id="element-3434">
                    <PieChart data-id="element-3435">
                      <Pie data={[{
                      name: 'Returning',
                      value: 65
                    }, {
                      name: 'New',
                      value: 35
                    }]} cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" paddingAngle={5} dataKey="value" data-id="element-3436">
                        <Cell fill="#8B5CF6" data-id="element-3437" />
                        <Cell fill="#F59E0B" data-id="element-3438" />
                      </Pie>
                    </PieChart>
                  </ResponsiveContainer>
                </div>
              </div>
              <div className="flex justify-center space-x-8 mt-4" data-id="element-3439">
                <div className="flex items-center" data-id="element-3440">
                  <div className="w-3 h-3 rounded-full bg-[#8B5CF6] mr-2" data-id="element-3441"></div>
                  <span className="text-sm" data-id="element-3442">Returning (65%)</span>
                </div>
                <div className="flex items-center" data-id="element-3443">
                  <div className="w-3 h-3 rounded-full bg-[#F59E0B] mr-2" data-id="element-3444"></div>
                  <span className="text-sm" data-id="element-3445">New (35%)</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3446">
            <h3 className="text-lg font-semibold mb-4" data-id="element-3447">
              Interests & Reaction Trends
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4" data-id="element-3448">
              <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg" data-id="element-3449">
                <div className="flex items-center" data-id="element-3450">
                  <div className="w-2 h-8 bg-purple-500 rounded-full mr-2" data-id="element-3451"></div>
                  <div data-id="element-3452">
                    <h4 className="font-medium" data-id="element-3453">Likes spicy content</h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3454">
                      87% engagement rate
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg" data-id="element-3455">
                <div className="flex items-center" data-id="element-3456">
                  <div className="w-2 h-8 bg-blue-500 rounded-full mr-2" data-id="element-3457"></div>
                  <div data-id="element-3458">
                    <h4 className="font-medium" data-id="element-3459">Comments on lives</h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3460">
                      65% engagement rate
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg" data-id="element-3461">
                <div className="flex items-center" data-id="element-3462">
                  <div className="w-2 h-8 bg-green-500 rounded-full mr-2" data-id="element-3463"></div>
                  <div data-id="element-3464">
                    <h4 className="font-medium" data-id="element-3465">Shares toy reviews</h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3466">
                      42% engagement rate
                    </p>
                  </div>
                </div>
              </div>
              <div className="p-3 border border-gray-200 dark:border-gray-700 rounded-lg" data-id="element-3467">
                <div className="flex items-center" data-id="element-3468">
                  <div className="w-2 h-8 bg-red-500 rounded-full mr-2" data-id="element-3469"></div>
                  <div data-id="element-3470">
                    <h4 className="font-medium" data-id="element-3471">Purchases premium</h4>
                    <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3472">
                      28% conversion rate
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="live" className="space-y-4" data-id="element-3473">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3474">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3475">
              <h3 className="text-lg font-semibold mb-4" data-id="element-3476">
                Live Stream Summary
              </h3>
              <div className="grid grid-cols-2 gap-4" data-id="element-3477">
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3478">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3479">
                    Total Duration
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3480">14.5 hours</h4>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3481">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3482">
                    Live Gifts
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3483">2,450</h4>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3484">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3485">
                    Diamonds Earned
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3486">12,800</h4>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3487">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3488">
                    Peak Viewers
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3489">1,240</h4>
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3490">
              <h3 className="text-lg font-semibold mb-4" data-id="element-3491">
                Live Conversion Rate
              </h3>
              <div className="h-40" data-id="element-3492">
                <ResponsiveContainer width="100%" height="100%" data-id="element-3493">
                  <BarChart data={[{
                  name: 'Viewers',
                  value: 1240
                }, {
                  name: 'Subscribers',
                  value: 348
                }]} margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5
                }} data-id="element-3494">
                    <CartesianGrid strokeDasharray="3 3" stroke="#374151" data-id="element-3495" />
                    <XAxis dataKey="name" stroke="#6B7280" data-id="element-3496" />
                    <YAxis stroke="#6B7280" data-id="element-3497" />
                    <Tooltip contentStyle={{
                    backgroundColor: '#1F2937',
                    borderColor: '#374151',
                    color: '#F9FAFB'
                  }} data-id="element-3498" />
                    <Bar dataKey="value" fill="#8B5CF6" data-id="element-3499" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
              <div className="mt-4 text-center" data-id="element-3500">
                <h4 className="text-lg font-bold" data-id="element-3501">28.1%</h4>
                <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3502">
                  Viewer to Subscriber Conversion
                </p>
              </div>
            </div>
          </div>
        </TabsContent>
        <TabsContent value="shop" className="space-y-4" data-id="element-3503">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3504">
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3505">
              <h3 className="text-lg font-semibold mb-4" data-id="element-3506">Shop Performance</h3>
              <div className="grid grid-cols-2 gap-4" data-id="element-3507">
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3508">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3509">
                    Product Views
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3510">8,320</h4>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3511">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3512">
                    Link Clicks
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3513">3,145</h4>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3514">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3515">
                    Orders
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3516">845</h4>
                </div>
                <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3517">
                  <p className="text-sm text-gray-500 dark:text-gray-400" data-id="element-3518">
                    GMV
                  </p>
                  <h4 className="text-xl font-bold mt-1" data-id="element-3519">$12,450</h4>
                </div>
              </div>
            </div>
            <div className="bg-white dark:bg-gray-800 p-4 rounded-xl shadow-sm" data-id="element-3520">
              <h3 className="text-lg font-semibold mb-4" data-id="element-3521">Most Sold Products</h3>
              <ul className="space-y-3" data-id="element-3522">
                <li className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3523">
                  <div className="flex items-center" data-id="element-3524">
                    <div className="w-10 h-10 bg-purple-100 dark:bg-purple-900 rounded-md flex items-center justify-center mr-3" data-id="element-3525">
                      <span className="text-purple-600 dark:text-purple-300 font-bold" data-id="element-3526">
                        1
                      </span>
                    </div>
                    <div data-id="element-3527">
                      <h4 className="font-medium" data-id="element-3528">Premium Lingerie Set</h4>
                      <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3529">
                        $89.99
                      </p>
                    </div>
                  </div>
                  <span className="font-medium" data-id="element-3530">245 sold</span>
                </li>
                <li className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3531">
                  <div className="flex items-center" data-id="element-3532">
                    <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900 rounded-md flex items-center justify-center mr-3" data-id="element-3533">
                      <span className="text-blue-600 dark:text-blue-300 font-bold" data-id="element-3534">
                        2
                      </span>
                    </div>
                    <div data-id="element-3535">
                      <h4 className="font-medium" data-id="element-3536">
                        Interactive Toy (Bluetooth)
                      </h4>
                      <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3537">
                        $129.99
                      </p>
                    </div>
                  </div>
                  <span className="font-medium" data-id="element-3538">187 sold</span>
                </li>
                <li className="flex items-center justify-between p-2 bg-gray-50 dark:bg-gray-700 rounded-lg" data-id="element-3539">
                  <div className="flex items-center" data-id="element-3540">
                    <div className="w-10 h-10 bg-green-100 dark:bg-green-900 rounded-md flex items-center justify-center mr-3" data-id="element-3541">
                      <span className="text-green-600 dark:text-green-300 font-bold" data-id="element-3542">
                        3
                      </span>
                    </div>
                    <div data-id="element-3543">
                      <h4 className="font-medium" data-id="element-3544">Signature Perfume</h4>
                      <p className="text-xs text-gray-500 dark:text-gray-400" data-id="element-3545">
                        $59.99
                      </p>
                    </div>
                  </div>
                  <span className="font-medium" data-id="element-3546">156 sold</span>
                </li>
              </ul>
            </div>
          </div>
        </TabsContent>
      </Tabs>
    </div>;
}